import React from "react";

function Icon({ width = "16", height = "16" }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 45.11 45.11"
			width={width}
			height={height}
		>
			<path
				d="M22.55 15.83a2.65 2.65 0 00-2.64 2.65V34a2.65 2.65 0 005.29 0V18.48a2.65 2.65 0 00-2.65-2.65m0-7.83a2.65 2.65 0 102.65 2.65A2.65 2.65 0 0022.55 8"
				fill="currentColor"
			/>
		</svg>
	);
}

export default Icon;
